import { Stack } from "@chakra-ui/react";
import PageHeader from "components/layout/PageHeader";
import { Header } from "../components/header";
import { FeesTable } from "../components/tables/fees-table";

export function Fees() {
  return (
    <>
      <PageHeader title="Fees" />

      <Stack gap={4}>
        <Header />
        <FeesTable />
      </Stack>
    </>
  );
}
